// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.promptToggleButton {
  height: 100%;
  width: 50%;
  border-radius: 39px;
}

.toggleButtonMainBox {
  background-color: rgba(235, 242, 254, 1);
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 230px;
  height: 43px;
  border-radius: 39px;
  cursor: pointer;
}

.QuickTermsButton {
  border-radius: 39px;
  padding: 8px 20px;
  /* height: 35px; */
  border: 1px solid rgba(143, 154, 188, 0.3);
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/Pages/PromptLibrary.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,wCAAwC;EACxC,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,0CAA0C;EAC1C,eAAe;AACjB","sourcesContent":[".promptToggleButton {\n  height: 100%;\n  width: 50%;\n  border-radius: 39px;\n}\n\n.toggleButtonMainBox {\n  background-color: rgba(235, 242, 254, 1);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 230px;\n  height: 43px;\n  border-radius: 39px;\n  cursor: pointer;\n}\n\n.QuickTermsButton {\n  border-radius: 39px;\n  padding: 8px 20px;\n  /* height: 35px; */\n  border: 1px solid rgba(143, 154, 188, 0.3);\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
